import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import withPixelRatio from 'shared/hocs/withPixelRatio';
import { getSpareDefaultImage } from 'shared/constants/defaultImages';
import s from './SpareImg.css';

const IMAGE_WIDTH = 70;

class SpareImg extends React.Component {
  static propTypes = {
    photos: PropTypes.arrayOf(PropTypes.shape()),
    defaultImg: PropTypes.string,
    setRatioAlbum: PropTypes.func.isRequired,
  };
  static defaultProps = {
    photos: null,
    defaultImg: getSpareDefaultImage(),
  };

  render() {
    const { photos, defaultImg, setRatioAlbum } = this.props;
    const resizedPhotos = setRatioAlbum(photos, IMAGE_WIDTH);
    return (
      <div style={{ padding: '0 15px 0 0' }}>
        <img
          className={s.spareImage}
          src={resizedPhotos && resizedPhotos.length > 0 ? resizedPhotos[0].image : defaultImg}
          alt=""
        />
      </div>
    );
  }
}

export default withStyles(s)(withPixelRatio(SpareImg));



// WEBPACK FOOTER //
// ./src/shared/components/SpareImg/SpareImg.js